module.exports = __webpack_public_path__ + "static/img/huaweiMate30Pro.fca27728.png";